// 项目配置
import { sidebarLayer } from '../../config/project.config.js'

const routerManage = {
  state: {
    routerList: [],
    categoryRouterList: [],
    sidebarRouterList: [],
    handleRightsList: [],
    indexRouter: '',
    detailName: ''
  },

  mutations: {
    SET_ROUTERLIST(state, routerList) {
      state.routerList = routerList
    },

    SET_CATEGORYROUTERLIST(state, categoryRouterList) {
      state.categoryRouterList = categoryRouterList
    },

    SET_SIDEBARROUTERLIST(state, sidebarRouterList) {
      state.sidebarRouterList = sidebarRouterList
    },

    SET_HANDLERIGHTSLIST(state, handleRightsList) {
      state.handleRightsList = handleRightsList
    },

    SET_INDEXROUTER(state, indexRouter) {
      state.indexRouter = indexRouter
    },
    DETAILNAME(state, detailName) {
      state.detailName = detailName
    }
  },

  actions: {
    // 权限筛选
    async filterRouter({ commit }, { routerList, roleList }) {
      let addRouterList = routerList
      let filterList = []
      for (const item of routerList[0].children) {
        if (!item.meta.rightName) {
          filterList.push(item)
        } else {
          for (const iterator of roleList) {
            if (iterator.name === item.meta.rightName) {
              filterList.push(item)
            }
          }
        }
      }
      addRouterList[0].children = filterList
      commit('SET_ROUTERLIST', addRouterList)
    },

    // sidebar
    async filterSidebarLayer({ commit, state }) {
      let sidebarRouterList = []
      for (const key in sidebarLayer) {
        let sidebarRouterItem = { type: sidebarLayer[key], routerList: [] }
        if (sidebarLayer[key] !== sidebarLayer.otherLayer) {
          for (const item of state.routerList[0].children) {
            if (item.meta.sidebarLayer === sidebarLayer[key]) {
              sidebarRouterItem.routerList.push(item)
            }
          }
        } else {
          for (const item of state.routerList[0].children) {
            if (
              !item.meta.sidebarLayer ||
              item.meta.sidebarLayer === sidebarLayer[key]
            ) {
              sidebarRouterItem.routerList.push(item)
            }
          }
        }
        sidebarRouterList.push(sidebarRouterItem)
      }
      commit('SET_SIDEBARROUTERLIST', sidebarRouterList)
    },

    // 首页
    async changeIndexRouter({ state, commit }) {
      for (const item of state.sidebarRouterList) {
        if (item.type === 'superLayer') {
          commit(
            'SET_INDEXROUTER',
            item.routerList[0]
              ? item.routerList[0].meta.hidden
                ? 'home'
                : item.routerList[0].name
              : 'home'
          )
        }
      }
    },

    // 初始化权限路由和首页
    async initRouterListIndexRouter({ dispatch }, { routerList, roleList }) {
      await dispatch('filterRouter', { routerList, roleList })
      await dispatch('filterSidebarLayer')
      await dispatch('changeIndexRouter')
    },

    // 当前路由的同一分类，此类目下操作权限
    async filterCategoryRouter(
      { commit, state },
      { rightName, roleList, category }
    ) {
      let categoryRouterList = []
      let handleRightsList = []
      let allCategoryRouterList = []
      for (const item of state.routerList[0].children) {
        if (item.meta.category === category) {
          allCategoryRouterList = item.children
          for (const iterator of roleList) {
            if (iterator.name === item.meta.rightName) {
              for (const childrenRouterItem of item.children) {
                if (!childrenRouterItem.meta.rightName) {
                  categoryRouterList.push(childrenRouterItem)
                } else {
                  for (const childrenNodeItem of iterator.childNodeList) {
                    if (
                      childrenNodeItem.name ===
                      childrenRouterItem.meta.rightName
                    ) {
                      categoryRouterList.push(childrenRouterItem)
                      if (rightName === childrenNodeItem.name) {
                        handleRightsList = childrenNodeItem.childNodeList
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (handleRightsList && handleRightsList.length > 0) {
        handleRightsList = handleRightsList.map(item => {
          return item.name
        })
      }

      // console.log(handleRightsList,categoryRouterList)
      commit('SET_HANDLERIGHTSLIST', handleRightsList)
      commit('SET_CATEGORYROUTERLIST', categoryRouterList)

      return allCategoryRouterList
    }
  }
}

export default routerManage
